import React, { Component } from 'react';
import { Row, Col, ProgressBar, Table } from "react-bootstrap";
import Select from 'react-select';
import Switch from "react-switch";
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";
import CustomModal from "../../../components/Modal/CustomModal";

import { CuotasDisp, CuotasDispSelect, CarrerasDisp, EstDisp, EstDispC, CobrarCuota, FinalizarCobro } from "../../../funciones/CobranzasFunction";

class Cuotas extends Component {
    state = {
        cuotas: "",
        cuotasDisp: [],
        cuotaSelect: { value: "", label: "- Selecciona una Cuota -" },
        aplicarA: { value: "todos", label: "APLICAR A TODOS" },
        aplica: [],
        boton1:{
            icon: "fa fa-money",
            text: "Cobrar",
            disabled: false
        },
        check: true,
        estCobro: [],
        openModalConfirm: false,
        openModalcobrOk: false,
        botonCobro: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        porcentaje: 0,
        estNoCuota:[]
    }

    componentDidMount = () => {
        CuotasDisp ((resp) => {
            this.setState({
                cuotas: parseInt(resp.cant_cuotas)
            })
        })

        CuotasDispSelect ((resp) => {
            this.setState({
                cuotasDisp: resp
            })
        })

        CarrerasDisp ((resp) => {
            this.setState({
                aplica: resp
            })
        }) 
    }

    valorSolicitud = (cuotaSelect) => {
        this.setState({
            cuotaSelect
        })
    }

    aplicarA = (aplicarA) => {
        this.setState({
            aplicarA
        })
    }

    addNotif = () => {
        this.setState({
            check: !this.state.check
        })
    }

    modalCobrOk = () => {
        let { openModalcobrOk, estNoCuota } = this.state;

        let NoCobrada = () => {
            if (estNoCuota.length === 0) return null;

            return (
                <div className="text-danger" style={{fontSize:11}}>
                    No se realizó el cobro de la cuota a <strong>{estNoCuota.length} estudiante(s)</strong> debido a que tiene(n) una verificación de pago pendiente
                </div>
            )
        }
        
        let contenido = () => (
            <React.Fragment>
                <div>
                    Se ha realizado correctamente el cobro de la <strong className="text-danger">CUOTA</strong> a los estudiantes seleccionados
                </div>
                {NoCobrada()}
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = ""
                boton1 = {<React.Fragment><i className="fa fa-check"></i> Ok</React.Fragment>}
                large = "medium"
                isopen =  {openModalcobrOk}
                titulo = "Cobro Realizado"
                contenido = {contenido()}      
                funcion1 = {() => {this.setState({ openModalcobrOk: false })}}
            />
        );
    }

    modalConfirm = () => {
        let { openModalConfirm, botonCobro, estCobro, cuotaSelect, check } = this.state;

        let notif = () => {
            if (check === false) return null;

            return (
                <div className="text-danger" style={{fontSize: 11}}>Tienes las noticaciones de Correo Electrónico activadas lo que puede hacer que el proceso tarde mucho mas</div>
            )
        }

        let cobroInd = (est, percent, respuesta) => {
            let slidePercent = 100 / ((estCobro.length - 1));
            CobrarCuota (estCobro[est].est, check, cuotaSelect, (resp) => {
                if (resp.status === "warning"){
                    toast.error(resp.mess,{autoClose: 6000});

                    let contenido = this.state.estNoCuota;
                    contenido.push(resp.est)
                    this.setState({
                        estNoCuota: contenido
                    })
                }

                this.setState({
                    porcentaje: Math.round(percent)
                }, () => {
                    if (est === (estCobro.length - 1)){
                        this.setState({
                            openModalcobrOk: true,
                            boton1:{
                                icon: "fa fa-money",
                                text: "Cobrar",
                                disabled: false
                            },
                            botonCobro: {
                                icon: "fa fa-check",
                                text: "Si",
                                disabled: false
                            },
                            porcentaje: 0
                        }, () => {
                            EstDispC (cuotaSelect.value, (resp) => {
                                if(resp === 0){
                                    FinalizarCobro (cuotaSelect.value, () => {
                                        CuotasDisp ((resp) => {
                                            this.setState({
                                                cuotas: parseInt(resp.cant_cuotas)
                                            })
                                        })
                                
                                        CuotasDispSelect ((resp) => {
                                            this.setState({
                                                cuotasDisp: resp,
                                                cuotaSelect: { value: "", label: "- Selecciona una Cuota -" },
                                            })
                                        })
                                    })
                                }
                            })
                        })
                    }
                })

                let estAct = est + 1;
                let perc = percent + slidePercent;
                if (estAct <= (estCobro.length - 1)) cobroInd(estAct, perc, (resp) => {})

                respuesta(1)
            })
        }

        let cobro = () => {
            if (botonCobro.disabled === true) return null;
            if (estCobro.length === 0) {
                this.setState({
                    openModalConfirm: false,
                    boton1:{
                        icon: "fa fa-money",
                        text: "Cobrar",
                        disabled: false
                    }
                })
                toast.info("No hay estudiantes disponibles en la(s) carrera(s) seleccionada(s)",{autoClose: 4000});
                return null;
            }
            
            this.setState({
                botonCobro: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                },
                openModalConfirm: false
            }, () => {
                let ni = 0;
                if (estCobro.length > 0) {
                    cobroInd(ni, 0, (resp) => { ni += resp })
                }
            })
        }

        let contenido = () => (
            <React.Fragment>
                {notif()}
                <div>Se le aplicará el cobro a <strong>{estCobro.length} estudiantes</strong> correspondiente a la <strong className="text-danger">{cuotaSelect.label}</strong>. ¿Deseas Continuar?</div>
                <div style={{fontSize: 11}} className="text-danger"><strong>IMPORTANTE: Si tienes estudiantes con verificación de pago pendiente no se le aplicará el cobro hasta que ese pago sea verificado</strong></div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={botonCobro.icon}></i> {botonCobro.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModalConfirm}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {cobro}
                funcion2 = {() => {this.setState({
                    openModalConfirm: false,
                    boton1:{
                        icon: "fa fa-money",
                        text: "Cobrar",
                        disabled: false
                    },
                    botonCobro: {
                        icon: "fa fa-check",
                        text: "Si",
                        disabled: false
                    }
                })}}
            />
        );
    }

    contenido = () => {
        const { cuotas, cuotasDisp, cuotaSelect, aplicarA, aplica, boton1, check, porcentaje, estNoCuota } = this.state;

        const customStyles = {
            option: (provided) => ({
              ...provided,
              fontSize: 10
            }),
        }

        let pendiente = () => {
            if (cuotas === "")return (
                <div><i className="fa fa-spinner fa-spin"></i> Cargando</div>
            )

            let contenido = [];
            for (let i = 1; i < cuotas; i++) {
                let clase = "btn btn-relleno-primary"
                
                for (let n in cuotasDisp){
                    if (cuotasDisp[n].value === (i + 1) ) clase = "btn btn-relleno-default"
                }

                contenido.push(
                    <span className={clase} style={{borderWidth:1}}>{i + 1}</span>
                )
            }

            return (
                <React.Fragment>
                    <span className="btn btn-relleno-primary" style={{borderWidth:1}}>1</span>
                    {contenido}
                </React.Fragment>
            )
        }

        let cobrarModal = () => {
            if (boton1.disabled === true) return null;

            if (cuotaSelect.value === "") {
                toast.error("Debes selecionar la cuota primero",{autoClose: 4000});
                return null;
            }

            this.setState({
                boton1: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true   
                }
            }, () => {
                EstDisp (cuotaSelect.value, aplicarA.value, (resp) => {
                    this.setState({
                        estCobro: resp,
                        openModalConfirm: true,
                    })
                })
            })
        }

        let messNoCuota = () => {
            if (estNoCuota.length === 0) return null;

            const styles = {
                padding: 5, fontSize: 12
            }

            let est = () => {
                let n = 0;
            
                return(
                    estNoCuota.map(option => {
                        n++;
                        return (
                            <tr key = {n}>
                                <td style={styles} align="center"><strong>{n}</strong></td>
                                <td style={styles}>{option}</td>
                            </tr> 
                        )
                    })
                )
            }

            return(
                <div className="custom-alert-info">
                    <div style={{fontSize: 12}} align="center"><strong>No se pudo realizar el cobro a los siguientes estudiantes porque tienen Verificaciones de Pago Pendiente</strong></div>
                    <div className="table-responsive" id="lisEstDeuda" onScroll={this.update} style={{overflowY: "auto", maxHeight: "40vh", backgroundColor: "fff"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="50px" align="center" style={styles}><strong>N°</strong></td>
                                    <td align="center" style={styles}><strong>Estudiante</strong></td>
                                </tr>
                                {est()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    Cuotas Pendientes
                </div>
                <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                    <Row>
                        <Col md={12} align="center">
                            <div className="btn-group">
                                {pendiente()}
                            </div>
                        </Col>
                    </Row>
                    <div align="center">Los numeros rellenos son cuotas ya cobradas</div>
                </div>

                <div className="custom-mt-10" style={{padding: 5}}>
                    <div style={{fontSize: 10}} className="text-danger">Progreso</div>
                    <ProgressBar now={porcentaje} striped style={{height: 12}}/>
                    <div align="center" style={{fontSize: 10}}>{parseInt(porcentaje)}%</div>
                </div>
                {messNoCuota()}
                <div className="custom-alert-danger custom-mt-10" style={{padding: 5}}>
                    <div>Cobrar Cuota</div>
                    <Row>
                        <Col md={4}>
                            <Select
                                isSearchable ={true}
                                value={cuotaSelect}
                                onChange={this.valorSolicitud}
                                options={cuotasDisp}
                            />
                        </Col>
                        <Col md={4}>
                            <Select
                                styles={customStyles}
                                isSearchable ={true}
                                value={aplicarA}
                                onChange={this.aplicarA}
                                options={aplica}
                            />
                        </Col>
                        <Col md={4} align="right">
                            <button className="btn btn-relleno-danger" onClick={cobrarModal} title="Esta opción permite aplicar el cobro de la cuota a los estudiantes seleccionados" style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                        </Col>
                    </Row>
                </div>

                <div className="custom-alert-danger custom-mt-10" style={{padding: 5}}>
                    <Row>
                        <Col md={3} align="center">
                            <Switch
                                height={12}
                                width={24}
                                onChange={this.addNotif}
                                checked={check}
                            />
                            <span style={{fontSize: 12, fontWeight: "bold"}}> Enviar Notificación</span>
                        </Col>
                        <Col md={9} align="Justify">
                            Esta opción enviará un correo de notificación de cobro a cada estudiante por lo que puede tardar varios minutos en realizarse. Una vez efectuado el cobro espera a que termine el proceso
                        </Col>
                    </Row>
                    </div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">Este módulo permite aplicar el cobro de las cuotas correspondientes a los aranceles de las materias incritas.</Col>
            
            <Col md={12} className="text-primary custom-mt-10"><strong>Paso 1</strong></Col>
            <Col md={12} align="justify">Para comenzar selecciona el <strong>Número de la Cuota</strong> (En este campo solo aparecerán las cuotas no cobradas)</Col>
            
            <Col md={12} className="text-primary custom-mt-10"><strong>Paso 2</strong></Col>
            <Col md={12} align="justify">Selecciona a quién se le aplicará el cobro (por defecto se encuentra en <strong>APLICAR A TODOS</strong>)</Col>
        
            <Col md={12} className="text-primary custom-mt-10"><strong>Paso 3</strong></Col>
            <Col md={12} align="justify">Presiona el botón <button className="btn btn-relleno-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Cobrar</button> y confirma para comenzar el proceso de cobro</Col>

            <Col md={12} className="custom-mt-10" align="justify">
                Al comenzar el proceso de cobro podrás ver una barra de progreso como esta: <ProgressBar now={45} striped style={{height: 12}}/> que te indica el porcentaje de estudiantes que se les ha aplicado el cobro
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                <strong>Es importante que esperes que se complete el proceso una vez que ha comenzado para evitar fallas del sistema</strong>
            </Col>
        </Row>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Cobro de Cuotas</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalConfirm()}
                {this.modalCobrOk()}
            </div>
        );
    }
}
 
export default Cuotas;


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/Cuotas.jsx